'use client';

import { useQuery } from '@tanstack/react-query';

import { fetchPrV2FileDescription } from './fetch-pr-v2';
import { prV2FileDescriptionQueryKey } from './query-keys';

const PR_V2_FILE_DESCRIPTION_PENDING_POLL_MS = 2000;

export function usePrV2FileDescription(
  owner: string,
  repo: string,
  number: string,
  options?: {
    headSha?: string | null;
    baseSha?: string | null;
    enabled?: boolean;
  },
) {
  return useQuery({
    queryKey: prV2FileDescriptionQueryKey(owner, repo, number, options?.headSha, options?.baseSha),
    queryFn: ({ signal }) =>
      fetchPrV2FileDescription(
        owner,
        repo,
        number,
        { headSha: options?.headSha, baseSha: options?.baseSha },
        signal,
      ),
    enabled:
      Boolean(owner && repo && number && options?.headSha && options?.baseSha) &&
      (options?.enabled ?? true),
    staleTime: Number.POSITIVE_INFINITY,
    refetchOnWindowFocus: false,
    refetchInterval: (query) =>
      query.state.data?.status === 'pending' ? PR_V2_FILE_DESCRIPTION_PENDING_POLL_MS : false,
  });
}
